import { EstadosOrdenTrabajoEnumChoice, useTableFilter, } from "@/shared";
import { useFetchOrdenTrabajos } from "@/shared/actions/erp";
import { CustomSearch, GeneralTable } from "@/shared/components/ui";
import { EstadoOrdenTrabajoCodigoEnum } from "@/shared/interfaces";
import { OrdenTrabajo, OrdenTrabajoWithProspectoData } from "@/shared/interfaces/erp/tecnico";
import { Grid } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";

type ITablaInstalacionProps = {
  estadoInstalacion: EstadoOrdenTrabajoCodigoEnum;
  columns: MRT_ColumnDef<OrdenTrabajoWithProspectoData>[]
}

const TablaInstalacionComponente = ({columns }: ITablaInstalacionProps) => {



  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

    dateBefore,
    dateAfter,
    onChangeRangeDate,
    cleanFilter

  } = useTableFilter();
  const { pageIndex } = pagination;

  const {
    data: instalacionesAgendadasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOrdenTrabajos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.REALIZADA,
      identificacion: searchTerm,
      fecha_hora_activacion_after: dateAfter,
      fecha_hora_instalacion_after: dateAfter,
      fecha_hora_activacion_before: dateBefore,
      fecha_hora_instalacion_before: dateBefore,
    }
  });

  return (
    <>
      <Grid>
        <Grid item>
          <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text=""

            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <GeneralTable<OrdenTrabajo>
          columns={columns}
          data={instalacionesAgendadasPagingRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={instalacionesAgendadasPagingRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          canDelete={false}
          positionActionsColumn='first'

          //
          enableColumnActions={false}
          enableEditing={false}

        />
      </Grid>


    </>
  );

}

export default TablaInstalacionComponente;